import type { Pivotable } from '@empathyco/playboard-core-domain'
import type { FiltersMessages, RegularFilterConfig } from '../models'
import { FilterTypeEnum } from '@empathybroker/tsclient-play/dist/enums/filter-type.enum'
import { getCurrentInstance } from 'vue'
import { FiltersUtils } from '../utils/filters.utils'
import { useFilters } from './use-filters'

export interface PivotableAuditComposable {
  transform: (payload: Pivotable) => PivotableAudit
}

export interface PivotableAudit {
  pivots: Record<string, string>
}

export function usePivotableAudit(): PivotableAuditComposable {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }
  const {
    proxy: { $epb },
  } = ctx

  const { filters } = useFilters()

  function transform(payload: Pivotable): PivotableAudit {
    const filterConfigs = Object.values(filters.value).map(filter => filter.config)
    const filtersMessages = $epb.messages.filters as FiltersMessages
    const pivots = payload.pivots.reduce((result, pivot) => {
      const filterConfig = FiltersUtils.findConfig(filterConfigs, {
        toolingId: pivot.name,
      }) as RegularFilterConfig
      const filterLabel =
        (filterConfig && FiltersUtils.getLabel(filterConfig, filtersMessages)) || pivot.name
      const filterValueLabels = pivot.values.map(pivotValue => {
        if (filterConfig?.type === FilterTypeEnum.REGULAR) {
          const filterValueConfig = FiltersUtils.findValueConfig(filterConfig.values, {
            taggingId: pivotValue,
          })
          if (filterValueConfig) {
            return FiltersUtils.getValueLabel(filterConfig, filterValueConfig, filtersMessages)
          }
        }
        return pivotValue
      })
      return {
        ...result,
        [filterLabel]: filterValueLabels.join(', '),
      }
    }, {})

    return {
      pivots,
    }
  }

  return {
    transform,
  }
}
